// appVersion.js
//
// One place the running version is written. It was a string literal in App.js,
// passed to Sidebar's About section; #172 added a second reader — the help
// window is told which version opened it, so the manual can say whether it was
// reviewed against that version or something older.
//
// Two copies of a version number is how a stamp starts lying. Import this.
//
// Not read from package.json on purpose: CRA would inline it at build time from
// a file whose `version` field nobody bumps deliberately, so the About box would
// quietly report 0.1.0 forever while this repo's actual pilot version moved.
// A constant that has to be edited by hand is edited on purpose.
export const APP_VERSION = "0.1.0-pilot";

export default APP_VERSION;
